import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import "typesafe-actions";
import { RealtimeMessageTrigger, RealtimeUpdatesMode } from "../../redux-folder/realtime/types.js";
import "normalizr";
import "rxjs";
import "rxjs/operators";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import { p2pPlayerSettingsMappingKeys } from "./mapper.js";
function useP2PPlayerSettings({
  viewType,
  uid,
  fields,
  validateFilter,
  entityType
}) {
  const mapper = useAutoMapper();
  const queryFields = fields.map(
    (field) => mapper.map(
      field,
      p2pPlayerSettingsMappingKeys.viewModelKeys,
      p2pPlayerSettingsMappingKeys.queryFields
    )
  );
  const {
    items,
    viewEntity: { status }
  } = useViewInit({
    viewType,
    entity: {
      entity: entityType,
      fields: queryFields
    },
    defaultFilters: [
      {
        key: "uid",
        value: uid
      }
    ],
    validateFilter: (value) => (validateFilter ? validateFilter(value) : true) && !!uid?.length,
    cleanDelay: 0,
    realtime: {
      entity: entityType,
      mode: RealtimeUpdatesMode.Silent,
      triggers: [{ type: RealtimeMessageTrigger.Update }]
    }
  });
  const vm = items?.length > 0 ? mapper.tryMap(
    items[0],
    p2pPlayerSettingsMappingKeys.serverModel,
    p2pPlayerSettingsMappingKeys.viewModel
  ) : null;
  return { item: vm?.model, isLoading: status === "inProgress" };
}
export {
  useP2PPlayerSettings
};
//# sourceMappingURL=hooks.js.map
